import { render, staticRenderFns } from "./GetProperties.vue?vue&type=template&id=98b3294a"
import script from "./GetProperties.vue?vue&type=script&lang=js"
export * from "./GetProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports